import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class CourseService
    extends BaseService {

    static async list(param) {
        return BaseService.callAPI('course/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('course/get/' + id);
    }

    static async save(course) {
        return BaseService.callAPI('course/save', course);
    }

    static async delete(id) {
        return BaseService.callAPI('course/delete/' + id);
    }

    static async runEnablementCompare(file) {
        return BaseService.postFile('course/enablement-compare', file);
    }

    static async runEnablementCompareExcel(results) {
        return BaseService.callAPI('course/enablement-compare-excel', {
            results,
            isDownload: true,
            fileName: 'EnablementCompare.xlsx'
        });
    }

    static async getHighestTierForInstructor(courseID, instructorID) {
        return BaseService.callAPI('course/get-highest-tier-for-instructor', { courseID, instructorID });
    }
    
}
